import { neverHere } from "../tsHelpers";

export const toFriendlyName = (type: PdfJobType) => {
  switch (type) {
    case PdfJobType.Itinerary:       return "Itinerary";
    case PdfJobType.ATOLCertificate: return "ATOL Certificate";
    default:
      neverHere(type);
  }
};
